module.exports = __webpack_public_path__ + "img/star.45dd5470.png";